import { RRuleForm } from "./RRuleForm.js";
import { useRegionTimezone } from "../../modules/Regions/hooks/useRegionTimezone.js";
import { useEffect } from "react";
import { FormLayout } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { getIn, useFormikContext } from "formik";
//#region src/components/RRule/FormikRRuleSchedule.tsx
var EMPTY_SCHEDULE = {
	durationMin: 60,
	rrule: ""
};
function toRRuleScheduleItem(value) {
	const item = Array.isArray(value) ? value[0] : value;
	if (!item || typeof item !== "object") return EMPTY_SCHEDULE;
	const rec = item;
	return {
		durationMin: typeof rec.durationMin === "number" && rec.durationMin >= 1 ? rec.durationMin : EMPTY_SCHEDULE.durationMin,
		rrule: typeof rec.rrule === "string" ? rec.rrule : ""
	};
}
function FormikRRuleSchedule({ hint: _hint = "required", label = "Schedule", lanes, name, regionId, subTitle }) {
	const { setFieldValue, values } = useFormikContext();
	const timezone = useRegionTimezone(regionId, { cacheStrategy: "cache-first" });
	const raw = getIn(values, name);
	const schedule = toRRuleScheduleItem(raw);
	const needsNormalize = Array.isArray(raw) || !raw || typeof raw !== "object" || typeof raw.durationMin !== "number";
	useEffect(() => {
		if (!needsNormalize) return;
		setFieldValue(name, schedule, false);
	}, [
		name,
		needsNormalize,
		schedule.durationMin,
		schedule.rrule,
		setFieldValue
	]);
	return /* @__PURE__ */ jsx(FormLayout.Section, {
		heading: label,
		horizontal: false,
		subTitle,
		children: /* @__PURE__ */ jsx(RRuleForm, {
			durationMin: schedule.durationMin,
			initialRRuleStringValue: schedule.rrule || "",
			lanes,
			onChangeSchedule: (next) => {
				setFieldValue(name, next);
			},
			timeZone: timezone
		})
	});
}
//#endregion
export { FormikRRuleSchedule, toRRuleScheduleItem };

//# sourceMappingURL=FormikRRuleSchedule.js.map